import "core-js/modules/es6.array.for-each";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import { patch, isBlocked } from '../../../utils.js';

function getNormalizedContextName(contextType) {
  return contextType === 'experimental-webgl' ? 'webgl' : contextType;
}

function initCanvasContextObserver(win, blockClass, blockSelector, setPreserveDrawingBufferToTrue) {
  var handlers = [];

  try {
    var restoreHandler = patch(win.HTMLCanvasElement.prototype, 'getContext', function (original) {
      return function (contextType) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        if (!isBlocked(this, blockClass, blockSelector, true)) {
          var ctxName = getNormalizedContextName(contextType);
          if (!('__context' in this)) this.__context = ctxName;

          if (setPreserveDrawingBufferToTrue && ['webgl', 'webgl2'].includes(ctxName)) {
            if (args[0] && typeof args[0] === 'object') {
              var contextAttributes = args[0];

              if (!contextAttributes.preserveDrawingBuffer) {
                contextAttributes.preserveDrawingBuffer = true;
              }
            } else {
              args.splice(0, 1, {
                preserveDrawingBuffer: true
              });
            }
          }
        }

        return original.apply(this, [contextType].concat(args));
      };
    });
    handlers.push(restoreHandler);
  } catch (_a) {
    console.error('failed to patch HTMLCanvasElement.prototype.getContext');
  }

  return function () {
    handlers.forEach(function (h) {
      return h();
    });
  };
}

export { initCanvasContextObserver as default };